/**
 * Deals a gallery's items into `rowCount` rows, left to right then top to bottom, so a multi-row
 * gallery reads in column order: items 1 and 2 stack in the first column, 3 and 4 in the second.
 */
export default function arrangeItemsInRows(items, rowCount) {
  const rows = Array.from({ length: rowCount }, () => []);

  for (let index = 0; index < items.length; index += 1) {
    rows[index % rowCount].push(items[index]);
  }

  return rows;
}
